document.addEventListener('DOMContentLoaded', () => {
   const header = document.querySelector('.wcl-header');

   if (!header) {
      return;
   }

   const root = document.documentElement;

   /*
   * This flag is set by scroll.js during anchor scrolling. 
   */
   const isAnchorScrolling = () =>
      root.dataset.wclAnchorScrolling === 'true';

   let lastScrollY = window.scrollY;
   let ticking = false;

   const syncWithScroll = () => {
      lastScrollY = window.scrollY;
   };

   window.addEventListener('scroll', () => {
      if (ticking) {
         return;
      }

      ticking = true;

      requestAnimationFrame(() => {
         ticking = false;

         const currentScrollY = window.scrollY;

         /*
         * Do not hide the header during anchor scrolling;
         * only synchronize the position.
          */
         if (isAnchorScrolling()) {
            header.classList.remove('is-hidden');
            lastScrollY = currentScrollY;
            return;
         }

         if (currentScrollY > lastScrollY && currentScrollY > 80) {
            header.classList.add('is-hidden');
         } else {
            header.classList.remove('is-hidden');
         }

         lastScrollY = currentScrollY;
      });
   });

   /*
   * Anchor scroll complete: show the header and store the position,
   * so that the next standard scroll starts from the final point.
    */
   window.addEventListener('wcl:anchor-scroll-end', () => {
      header.classList.remove('is-hidden');
      syncWithScroll();
   });

   if (isAnchorScrolling()) {
      header.classList.remove('is-hidden');
   }


   /*
   * Header Height Calculation
   */
   const setHeaderHeight = () => {
      document.documentElement.style.setProperty(
         '--header-height',
         header.offsetHeight + 'px'
      );
   };

   setHeaderHeight();

   // recalculate whenever the header size changes
   new ResizeObserver(setHeaderHeight).observe(header);
});